import script from "./[equipment].vue?vue&type=script&setup=true&lang=ts"
export * from "./[equipment].vue?vue&type=script&setup=true&lang=ts"

import "./[equipment].vue?vue&type=style&index=0&id=98151994&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98151994"]])

export default __exports__